import React, { useState, useEffect } from "react";
import InputField from "../../reusables/input";
import Spinner from "../../reusables/spinner";
import { motion } from "framer-motion";
import { update_operations, get_settings } from "../../../redux/actions/adminActions";
import { connect } from "react-redux";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";
import Dropdown from "../../reusables/dropdown";
import { timeList, timeLocal, time_out } from "../../../utils/options";

function Operations({ updateOperations, settings, accessToken, getSettings }) {
  const [prevData, setPrevData] = useState(settings);

  const [formData, setData] = useState({
    booking_id_prefix: settings?.booking_prefix || "",
    search_radius_in_km: settings?.radius_in_km || "",
    unit_cost_per_km: settings?.cost_per_km || "",
    supplier_order_buffer_time: settings?.supplier_order_buffer_time || "",
    supplier_order_buffer_time_local: settings?.supplier_order_buffer_time_local || "",
    supplier_order_time_out: settings?.supplier_order_time_out || "",
    supplier_order_alert_cycle: settings?.supplier_order_alert_cycle || "",
    supplier_payment_delays: settings?.supplier_payment_delays || "",
    map_distance_factor: settings?.map_distance_factor || "",
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (settings) {
      setPrevData(settings);
      setData({
        booking_id_prefix: settings?.booking_prefix || "",
        search_radius_in_km: settings?.radius_in_km || "",
        unit_cost_per_km: settings?.cost_per_km || "",
        supplier_order_buffer_time: settings?.supplier_order_buffer_time || "",
        supplier_order_buffer_time_local: settings?.supplier_order_buffer_time_local || "",
        supplier_order_time_out: settings?.supplier_order_time_out || "",
        supplier_order_alert_cycle: settings?.supplier_order_alert_cycle || "",
        supplier_payment_delays: settings?.supplier_payment_delays || "",
        map_distance_factor: settings?.map_distance_factor || "",
      });
    }
  }, [settings]);

  const handleChange = (e, is_input = true, field_name) => {
    if (is_input) {
      setData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    } else {
      setData({
        ...formData,
        [field_name]: e,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);
    updateOperations(formData, accessToken, () => {
      getSettings(accessToken, () => {
        setIsLoading(false);
      });
    });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="sectionHeight--mid">
        <div className="row">
          <div className="col-lg-7">
            <form className="py-3 px-2" onSubmit={handleSubmit}>
              <div className="mt-3 mb-3">
                <InputField
                  label="Booking ID Prefix *"
                  name="booking_id_prefix"
                  value={formData?.booking_id_prefix}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  label="Search Radius in KM *"
                  name="search_radius_in_km"
                  value={formData?.search_radius_in_km}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  label="Transport cost per KM (NGN) *"
                  name="unit_cost_per_km"
                  value={formData?.unit_cost_per_km}
                  onChange={handleChange}
                />
              </div>

              {/* <div className="mt-3 mb-3">
                                <div className='d-flex'> */}
              {/* <InputField label="Supplier’s Order Buffer Time (Nigerian Local Time)" name='supplier_order_buffer_time'
                                        value={ formData.supplier_order_buffer_time }
                                        onChange={ handleChange }/> */}

              {/* <Dropdown label="Supplier’s Order Buffer Time (Nigerian Local Time)" value={ '' } className='flex-2 w-full'>
                                        <div className="isClickable hoverGreen">
                                            <p className="sectionText px-3 py-2 mb-0" >AM</p>
                                        </div>
                                        <div className="isClickable hoverGreen">
                                            <p className="sectionText px-3 py-2 mb-0" >AM</p>
                                        </div>
                                    </Dropdown>

                                    <Dropdown value={ '' } className='mx-1'>
                                        <div className="isClickable hoverGreen">
                                            <p className="sectionText px-3 py-2 mb-0" >AM</p>
                                        </div>
                                        <div className="isClickable hoverGreen">
                                            <p className="sectionText px-3 py-2 mb-0" >AM</p>
                                        </div>
                                    </Dropdown> */}
              {/* </div>
                            </div> */}

              <div className="row pt-2 pb-2 align-items-end">
                <div className="col-lg-9">
                  <div className="">
                    <p className="sectionText--small mb-1 textIsBold lAlign">
                      Supplier’s Order Buffer Time (Nigerian Local Time) *
                    </p>
                    <Dropdown
                      long
                      value={formData?.supplier_order_buffer_time || "Select"}
                    >
                      {timeList.map((time) => (
                        <div
                          className="isClickable hoverGreen lAlign"
                          onClick={() =>
                            handleChange(
                              time,
                              false,
                              "supplier_order_buffer_time"
                            )
                          }
                          key={time}
                        >
                          <p className="sectionText px-3 py-2 mb-0">{time}</p>
                        </div>
                      ))}
                    </Dropdown>
                  </div>
                </div>
                <div className="col-lg-3">
                  <Dropdown
                    long
                    value={formData?.supplier_order_buffer_time_local || "AM"}
                  >
                    {timeLocal.map((type) => (
                      <div
                        className="isClickable hoverGreen lAlign"
                        onClick={() =>
                          handleChange(
                            type,
                            false,
                            "supplier_order_buffer_time_local"
                          )
                        }
                        key={type}
                      >
                        <p className="sectionText px-3 py-2 mb-0">{type}</p>
                      </div>
                    ))}
                  </Dropdown>
                </div>
              </div>

              <div className="mt-3 mb-3">
                {/* <InputField label="Supplier’s Order Time Out" name='supplier_order_time_out'
                                    value={ formData.supplier_order_time_out }
                                    onChange={ handleChange }/> */}

                <div className="">
                  <p className="sectionText--small mb-1 textIsBold lAlign">
                    Supplier’s Order Time Out *
                  </p>
                  <Dropdown
                    long
                    value={formData?.supplier_order_time_out ? `+${formData.supplier_order_time_out}` : "Select"}
                  >
                    {time_out.map((time) => (
                      <div
                        className="isClickable hoverGreen lAlign"
                        onClick={() =>
                          handleChange(time, false, "supplier_order_time_out")
                        }
                        key={time}
                      >
                        <p className="sectionText px-3 py-2 mb-0">+{time}</p>
                      </div>
                    ))}
                  </Dropdown>
                </div>
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  label="Supplier’s Order Alert Cycle *"
                  name="supplier_order_alert_cycle"
                  value={formData?.supplier_order_alert_cycle}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  label="Supplier Payment delays (No. of days after order completion) *"
                  name="supplier_payment_delays"
                  value={formData?.supplier_payment_delays}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  label="Map Distance Factor *"
                  name="map_distance_factor"
                  value={formData?.map_distance_factor}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-4">
                {isLoading ? (
                  <button className="btn__filled textIsBold alignOnly" disabled>
                    Please Wait {""}
                    <Spinner />
                  </button>
                ) : (
                  <button className="btn__filled textIsBold">
                    Save Changes
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  settings: state.admin.settings,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  updateOperations: (data, token, success) => dispatch(update_operations(data, token, success)),
  getSettings: (token, success) => dispatch(get_settings(token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Operations);
